'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _iBem = require('../i-bem/i-bem.react');

var _eHidden = (require('./__hidden/search2__hidden.react.js').default || require('./__hidden/search2__hidden.react.js')).applyDecls();

var _eHidden2 = _interopRequireDefault(_eHidden);

var _eInput = (require('./__input/search2__input.react.js').default || require('./__input/search2__input.react.js')).applyDecls();

var _eInput2 = _interopRequireDefault(_eInput);

var _eButton = (require('./__button/search2__button.react.js').default || require('./__button/search2__button.react.js')).applyDecls();

var _eButton2 = _interopRequireDefault(_eButton);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = (0, _iBem.decl)({
    block: 'search2',
    tag: 'form',
    attrs: function attrs(_ref) {
        var url = _ref.url,
            label = _ref.label;

        return _extends({}, this.__base.apply(this, arguments), {
            role: 'search',
            action: url,
            'aria-label': label
        });
    },
    mods: function mods(_ref2) {
        var theme = _ref2.theme;

        return { theme: theme };
    },
    content: function content(_ref3) {
        var input = _ref3.input,
            button = _ref3.button,
            children = _ref3.children,
            hidden = _ref3.hidden;

        return [].concat(input && _react2.default.createElement(_eInput2.default, { key: 'input', input: input }), button && _react2.default.createElement(_eButton2.default, { key: 'button', button: button }), children,
        // В поле hidden передается словарь name/value, который преобразуется
        // в массив элементов hidden с соответствующими атрибутами name/value.
        hidden && Object.keys(hidden).map(function (key) {
            return _react2.default.createElement(_eHidden2.default, { value: hidden[key], name: key, key: 'hidden' + key });
        }));
    }
}, {
    Input: _eInput2.default,
    Button: _eButton2.default,
    propTypes: {
        // One of these is required
        theme: _propTypes2.default.string,
        template: _propTypes2.default.string,

        // Proxy props for input
        text: _propTypes2.default.string,
        onChange: _propTypes2.default.func,

        input: _propTypes2.default.object, // React.Component instance
        button: _propTypes2.default.object, // React.Component instance
        hidden: _propTypes2.default.array,
        url: _propTypes2.default.string,
        label: _propTypes2.default.string
    }
});